<script setup lang="ts">
/**
 * Square checkbox from the template's login form. The label is the default
 * slot so it can contain links (terms, privacy).
 */
const props = defineProps<{
  id?: string
  required?: boolean
  disabled?: boolean
  name?: string
}>()

const model = defineModel<boolean>({ default: false })

// useId() matches between the server render and the browser; a random id did not (hydration mismatch).
const fallbackId = `sofax-check-${useId()}`
const inputId = computed(() => props.id || fallbackId)
</script>

<template>
  <label :for="inputId" class="flex cursor-pointer items-start gap-[0.625rem] text-base text-body dark:text-gray-300">
    <input
      :id="inputId"
      v-model="model"
      type="checkbox"
      :name="name"
      :required="required"
      :disabled="disabled"
      class="field-check mt-0.5"
    >
    <span class="flex-1 leading-relaxed"><slot /></span>
  </label>
</template>
